<template>
  <div>
    <b-button squared variant="cms_main" type="button" v-b-modal.modalSalesModal
      ><b-icon icon="plus-circle" class="mr-2"></b-icon>新增管理者</b-button
    >
    <b-alert class="mt-4" variant="warning" show
      ><b-icon icon="exclamation-diamond-fill" class="mr-2"></b-icon
      >注意：停用管理者後即可刪除管理者。</b-alert
    >
    <div class="pt-4">
      <b-table
        v-if="!isMobile"
        responsive
        striped
        hover
        bordered
        head-variant="light"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的管理者"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(zones)="data">
          <div v-if="data.item.job_title == 'Admin'">全部</div>
          <span
            v-else
            v-for="(item, index) in data.item.zones"
            :key="item.aliases_id"
          >
            <span v-if="index">、</span>
            {{ item.aliases_name }}
          </span>
        </template>
        <template v-slot:cell(status)="data">
          <div class="status-switch" v-if="data.item.job_title !== 'Admin'">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.status"
              @click="changeStatus('switch-' + data.index, data.item.id)"
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              ><b-icon icon="pencil-square" class="mr-2"></b-icon
              >編輯</b-dropdown-item
            >
            <b-dropdown-divider v-if="!data.item.status"></b-dropdown-divider>
            <b-dropdown-item
              v-if="!data.item.status"
              href="#"
              @click="dele(data.item.id)"
              ><span class="text-danger"
                ><b-icon icon="trash" class="mr-2"></b-icon>刪除</span
              ></b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>

      <b-table
        v-else
        striped
        bordered
        head-variant="light"
        :items="items"
        :fields="fields_mobile"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的管理者"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(show_details)="row">
          <div class="btn-only-icon">
            <b-button
              @click="row.toggleDetails"
              class="btn-link border-0"
              variant="outline-light"
              size="sm"
            >
              <b-icon
                :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'"
                variant="dark"
              ></b-icon>
            </b-button>
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div class="status-switch">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.status"
              @click="changeStatus('switch-' + data.index, data.item.id)"
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              ><b-icon icon="pencil-square" class="mr-2"></b-icon
              >編輯</b-dropdown-item
            >
            <b-dropdown-divider v-if="!data.item.status"></b-dropdown-divider>
            <b-dropdown-item
              v-if="!data.item.status"
              href="#"
              @click="dele(data.item.id)"
              ><span class="text-danger"
                ><b-icon icon="trash" class="mr-2"></b-icon>刪除</span
              ></b-dropdown-item
            >
          </b-dropdown>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-3">
              <b-col sm="3"><b>姓名</b></b-col>
              <b-col>{{ row.item.name }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>手機號碼</b></b-col>
              <b-col>{{ row.item.telephone }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>稱謂</b></b-col>
              <b-col>{{ row.item.job_title }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>業務區域</b></b-col>
              <b-col>
                <span
                  v-for="(item, index) in row.item.zones"
                  :key="item.aliases_id"
                >
                  <span v-if="index">、</span>
                  {{ item.aliases_name }}
                </span>
              </b-col>
            </b-row>
            <b-row class="">
              <b-col class="text-center">
                <b-button
                  size="sm"
                  squared
                  variant="cms_main"
                  @click="row.toggleDetails"
                  >收起詳細資訊</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>

      <div class="row align-items-center" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
          {{
            currentPage == 1
              ? totalRows > perPage
                ? perPage
                : totalRows
              : perPage * (currentPage - 1) + perPage > totalRows
              ? totalRows
              : perPage * (currentPage - 1) + perPage
          }}
          項結果，共 {{ totalRows }} 項
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3 cms_main"
          ></b-pagination>
        </div>
      </div>
    </div>
    <b-modal
      id="modalSalesModal"
      :title="modal_title"
      footer-class="d-flex justify-content-between"
      no-close-on-backdrop
      centered
      tall
      @ok="onSubmit"
      @show="showModal"
      @hidden="hiddenModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="姓名"
          label-for="salesName"
          invalid-feedback="請填寫姓名"
          :state="state.name"
          class="required"
        >
          <b-form-input
            id="salesName"
            class="rounded-0"
            v-model="form.name"
            type="text"
            required
            placeholder="業務姓名"
            :state="state.name"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="手機號碼"
          label-for="salesTelephone"
          :invalid-feedback="invalidFeedbackTelephone"
          :state="state.telephone"
          class="required"
        >
          <b-form-input
            id="salesTelephone"
            class="rounded-0"
            v-model="form.telephone"
            type="text"
            required
            placeholder="手機號碼"
            :state="state.telephone"
            :disabled="isEdit"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="稱謂"
          label-for="salesJob"
          invalid-feedback="請填寫管理者稱謂"
          :state="state.job_title"
          class="required"
        >
          <b-form-input
            id="salesJob"
            class="rounded-0"
            v-model="form.job_title"
            type="text"
            required
            placeholder="管理者稱謂"
            :state="state.job_title"
            :disabled="form.job_title == 'Admin'"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          v-if="form.job_title !== 'Admin'"
          label="選擇業務區域(複選)"
          label-for="salesZone"
          invalid-feedback="請選擇業務區域"
          :state="state.zones"
          class="required"
        >
          <vSelect
            class="style-chooser"
            multiple
            placeholder="請選擇"
            v-model="form.aliases_id"
            :options="zones_list"
            label="aliases_name"
            :selectable="option => !option.selected"
            @input="markSelectedZonesList"
          >
          </vSelect>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button squared variant="outline-dark" type="button" @click="cancel()"
          >取消</b-button
        >
        <b-button squared variant="cms_main" type="submit" @click="ok()"
          >儲存</b-button
        >
      </template>
    </b-modal>
  </div>
</template>
<style lang="scss">
.style-chooser {
  .vs__dropdown-menu {
    .vs__dropdown-option--disabled {
      display: none;
    }
  }
}
</style>
<script>
import { Swal, Toast } from "@/plugins/sweetalert2.js";
import { Account, Zone } from "@/assets/api/cms.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "Salesman",
  props: ["search", "isMobile", "token"],
  components: { vSelect },
  data() {
    return {
      currentPage: 1,
      edit_id: null,
      fields: [
        {
          key: "name",
          label: "姓名",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "job_title",
          label: "稱謂",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "telephone",
          label: "手機號碼",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "zones",
          label: "業務區域",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "status",
          label: "狀態",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      fields_mobile: [
        {
          key: "show_details",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        },
        {
          key: "name",
          label: "姓名",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "status",
          label: "狀態",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      filter: null,
      filterOn: ["name"],
      form: {
        job_title: "",
        name: "",
        telephone: "",
        aliases_id: [],
        role: "Admin"
      },
      isEdit: false,
      isModalShow: false,
      items: null,
      modal_title: "新增業務",
      perPage: 10,
      state: {
        name: null,
        job_title: null,
        telephone: null,
        zones: null
      },
      totalRows: null,
      zones_list: [],
      invalidFeedbackTelephone: "請填寫手機號碼"
    };
  },
  computed: {
    filterZonesList() {
      if (!this.items) return;
      let allItemZone = [];
      this.items.forEach(item => {
        item.zones.forEach(val => {
          allItemZone.push(val);
        });
      });
      let newZonesList = JSON.parse(JSON.stringify(this.zones_list));
      for (let index = 0; index < allItemZone.length; index++) {
        newZonesList = newZonesList.filter(zones => {
          return zones.aliases_id !== allItemZone[index].aliases_id;
        });
      }
      if (this.isEdit) {
        this.items.forEach(item => {
          if (item.id == this.edit_id) {
            item.zones.forEach(zones => {
              newZonesList.push({
                aliases_id: zones.aliases_id,
                aliases_name: zones.aliases_name
              });
            });
          }
        });
      }
      return newZonesList;
    }
  },
  created() {
    this.perPage = process.env.VUE_APP_TABLE_ROW_LENGTH || 15;
    this.filter = this.$route.query.search;
    this.getAccount();
    Zone.get("", this.token)
      .then(res => {
        if (res.status <= 201) {
          res.data.forEach(val => {
            this.zones_list.push({
              aliases_id: val.id,
              aliases_name: val.aliases_name
            });
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "地區資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(err => {
        console.error(err);
      });
  },
  watch: {
    form: {
      handler: function() {
        if (this.isModalShow && this.isEdit) {
          this.checkFormState();
        }
      },
      deep: true
    }
  },
  methods: {
    markSelectedZonesList() {
      for (let i = 0; i < this.zones_list.length; i++) {
        let selected = false;
        for (let j = 0; j < this.form.aliases_id.length; j++) {
          if (
            this.zones_list[i].aliases_id == this.form.aliases_id[j].aliases_id
          ) {
            selected = true;
            break;
          }
        }
        this.zones_list[i].selected = selected;
      }
    },
    getAccount() {
      Account.get("", this.token)
        .then(res => {
          if (res.status <= 201) {
            this.items = res.data.Admin;
            this.totalRows = this.items.length;
          } else {
            Toast.fire({
              icon: "error",
              title: "管理者資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    changeStatus(ele, id) {
      if (!document.getElementById(ele).checked) {
        Swal.fire({
          title: "更改為停用狀態",
          text: "確定要停用嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "停用"
        }).then(result => {
          if (result.value) {
            Account.status(id, { status: 0 }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "修改成功"
                  });
                  document.getElementById(ele).checked = false;
                  this.getAccount();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "修改失敗",
                    text: res.data.error
                  });
                  document.getElementById(ele).checked = true;
                }
              })
              .catch(err => {
                console.error(err);
                document.getElementById(ele).checked = true;
              });
          } else {
            document.getElementById(ele).checked = true;
          }
        });
      } else {
        Swal.fire({
          title: "更改為啟用狀態",
          text: "確定要啟用嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "啟用"
        }).then(result => {
          if (result.value) {
            Account.status(id, { status: 1 }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "修改成功"
                  });
                  document.getElementById(ele).checked = true;
                  this.getAccount();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "修改失敗",
                    text: res.data.error
                  });
                  document.getElementById(ele).checked = false;
                }
              })
              .catch(err => {
                console.error(err);
                document.getElementById(ele).checked = true;
              });
          } else {
            document.getElementById(ele).checked = false;
          }
        });
      }
    },
    resetForm() {
      this.modal_title = "新增管理者";
      this.isEdit = false;
      this.edit_id = null;

      this.state.name = null;
      this.state.telephone = null;
      this.state.zones = null;
      this.state.job_title = null;

      this.form.name = "";
      this.form.telephone = "";
      this.form.aliases_id = [];
      this.form.job_title = "";
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      this.invalidFeedbackTelephone = "請填寫手機號碼";
      this.form.name ? (this.state.name = null) : (this.state.name = false);
      this.form.telephone
        ? (this.state.telephone = null)
        : (this.state.telephone = false);
      this.form.job_title
        ? (this.state.job_title = null)
        : (this.state.job_title = false);
      this.form.aliases_id.length
        ? (this.state.zones = null)
        : (this.state.zones = false);
    },
    edit(id) {
      this.resetForm();
      this.isEdit = true;
      this.edit_id = id;
      this.$root.$emit("bv::show::modal", "modalSalesModal", "#btnShow");
    },
    dele(id) {
      Swal.fire({
        title: "刪除",
        text: "確定要刪除此業務嗎？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          Account.delete(id, this.token)
            .then(res => {
              if (res.status <= 201) {
                Toast.fire({
                  icon: "success",
                  title: "刪除成功"
                });
                this.getAccount();
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    showModal() {
      this.isModalShow = true;
      if (this.isEdit) {
        this.modal_title = "編輯管理者";
        Account.get(this.edit_id, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.form.name = res.data.name;
              this.form.job_title = res.data.job_title;
              this.form.telephone = res.data.telephone;
              res.data.zones.forEach(val => {
                this.form.aliases_id.push({
                  aliases_id: val.aliases_id,
                  aliases_name: val.aliases_name
                });
              });
              this.markSelectedZonesList();
            } else {
              Toast.fire({
                icon: "error",
                title: "無法取得管理者資料",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        this.resetForm();
        this.markSelectedZonesList();
      }
    },
    hiddenModal() {
      this.isModalShow = false;
      this.resetForm();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      for (const value of Object.keys(this.state)) {
        if (this.state[value] === false) {
          return;
        }
      }
      let newData = Object.assign({}, this.form);
      newData.zone_alias_id = [];
      newData.aliases_id.forEach(val => {
        newData.zone_alias_id.push(val.aliases_id);
      });
      delete newData.aliases_id;

      if (this.isEdit) {
        delete newData.telephone;
        Account.update(this.edit_id, newData, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "編輯成功"
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalSalesModal",
                "#btnShow"
              );
              this.getAccount();
            } else {
              Toast.fire({
                icon: "error",
                title: "編輯失敗",
                text: res.data.error
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalSalesModal",
                "#btnShow"
              );
            }
          })
          .catch(error => {
            console.error(error);
            this.$root.$emit("bv::hide::modal", "modalSalesModal", "#btnShow");
          });
      } else {
        Account.create(newData, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "新增成功"
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalSalesModal",
                "#btnShow"
              );
              this.getAccount();
            } else {
              if (res.data.validated_message.telephone.length) {
                this.state.telephone = false;
                this.invalidFeedbackTelephone =
                  res.data.validated_message.telephone[0];
              } else {
                Toast.fire({
                  icon: "error",
                  title: "新增失敗",
                  text: res.data.error
                });
              }
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    }
  }
};
</script>
